/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { CreditCardCheckout } from './CreditCardCheckout';

/**
 * CreditCardTabPanel Component
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export function CreditCardTabPanel(props) {
  const {
    value,
    index,
    ...other
  } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <CreditCardCheckout />
        </Box>
      )}
    </Box>
  );
}

CreditCardTabPanel.propTypes = {
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};
